// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_gs-1";
export var rowFirst = "_gs-3";
export var rowLast = "_gs-5";
export var rowMiddle = "_gs-4";
export var ticketListScroll = "_gs-2";
export var ticketStack = "_gs-0";